import { emergenciaPages } from "./pages-emergencia";
import { automotivoPages, bairroPages } from "./pages-automotivo";
import { produtoPages } from "./pages-produtos";
import { novasAutomotivoPages, novasBairroPages } from "./pages-novas";
import type { ServicePage } from "./types";

export const servicePages: ServicePage[] = [
  ...emergenciaPages,
  ...automotivoPages,
  ...novasAutomotivoPages,
  ...bairroPages,
  ...novasBairroPages,
  ...produtoPages,
];

export const pagesBySlug: Record<string, ServicePage> = Object.fromEntries(
  servicePages.map((page) => [page.slug, page]),
);

export function getPage(slug: string): ServicePage | undefined {
  return pagesBySlug[slug];
}

export const categoryLabels: Record<ServicePage["category"], string> = {
  emergencia: "Emergência 24h",
  automotivo: "Automotivo",
  bairro: "Bairros de Betim",
  produto: "Fechaduras e portões",
  geral: "Serviços gerais",
};

export type { ServicePage };
